<template>
     <b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
     </b-overlay>
</template>

<script>

  export default {
    mounted() {
        this.whoami();
    },
    methods: {
        whoami() {
            this.$root.$data.bsLoader = true;
            axios.post("whoami").then(response => {
                if (response.data && response.data.has_auth) {
                    if (response.data.force_redirect) {
                        // use  r for super admin panel
                        window.location.href = response.data.force_redirect;
                        return;
                    }
                    
                    this.$store.commit(
                        "setUserLoggedIn",
                        response.data.vuex_data
                    );
                    window.axios.defaults.headers.common["Authorization"] =
                        "Bearer " + response.data.token;
                    
                    if (
                        !response.data.vuex_data.user.phone_verified_at &&
                        response.data.vuex_data.role == "contractor" &&
                        response.data.vuex_data.invited_user == false
                    ) {
                        // checking if phone is verified
                        this.$router.push({
                            name: "verify-phone"
                        });
                    } else if (
                        !response.data.vuex_data.user.email_verified_at
                    ) {
                        // checking if email is verified
                        if (
                            this.$route.query.redirectFrom &&
                            this.$route.query.redirectFrom.indexOf(
                                "/verify-email/"
                            ) >= 0
                        ) {
                            this.$router.push({
                                path: this.$route.query.redirectFrom
                            });
                        } else {
                            this.$router.push({
                                name: "verify-email"
                            });
                        }
                    } else if (response.data.vuex_data.role == "manager") {
                        console.log('manager', response.data.vuex_data)
                        // handling incomplete registration of manager
                        if (
                            !response.data.vuex_data.business &&
                            response.data.vuex_data.user.registration_status == "uncompleted" &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                name: "register-manager",
                                params: {step: 1}
                            });
                        } else if (
                            response.data.vuex_data.user.registration_status == "uncompleted" &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                name: "register-manager",
                                params: {step: 2}
                            });
                        } else if (
                            response.data.vuex_data.user.remember_token == sessionStorage.getItem('authenticatedUserToken') &&
                            response.data.vuex_data.user.registration_status == "completed" &&
                            this.$route.query.redirectFrom &&
                            response.data.vuex_data.invited_user == false &&
                            !this.$route.query.redirectFrom.includes('contractor')
                        ) {
                            this.$router.push({
                                path: this.$route.query.redirectFrom
                            });
                        } else {
                            this.$router.push({
                                name: "manager-dashboard"
                            });
                        }
                    } else if (response.data.vuex_data.role == "contractor") {
                                     
                        // handling incomplete registration of contractor
                        if (
                            !response.data.vuex_data.business &&
                            response.data.vuex_data.user.registration_status == "uncompleted" &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                name: "register-contractor",
                                params: {step: 1}
                            });
                        } else if (
                            response.data.vuex_data.user.registration_status == "uncompleted" &&
                            response.data.vuex_data.invited_user == false
                        ) {
                            this.$router.push({
                                name: "register-contractor",
                                params: {step: 2}
                            });
                        } else if (
                            response.data.vuex_data.user.remember_token == sessionStorage.getItem('authenticatedUserToken') &&
                            response.data.vuex_data.user.registration_status == "completed" &&
                            this.$route.query.redirectFrom &&
                            response.data.vuex_data.invited_user == false &&
                            !this.$route.query.redirectFrom.includes('manager')
                        ) {
                            this.$router.push({
                                path: this.$route.query.redirectFrom
                            });
                        } else {
                            this.$router.push({
                                name: "contractor-dashboard"
                            });
                        }
                    }
                }else{
                    this.$router.push({
                        name: "home"
                    });
                }
                this.$root.$data.bsLoader = false;
            }).catch((err) => {
                this.$root.$data.bsLoader = false;
            });
        },
    }
  }

</script>


